'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	title: 'Logged Out',
	message: 'You were logged out by the camp leader.',
	image: 'modal-warning'
});
